const defaultApiUrl = 'https://app-siiapp-prod-001.azurewebsites.net/';

const config = {
  apiUrl: process.env.REACT_APP_API_URL || defaultApiUrl,
};

export default config;
